import styled from '@emotion/styled'

export const Wrapper = styled.div`
    margin: 10px;
    border-radius: 16px;
`

export const Title = styled.div`
    margin-bottom: 20px;
    text-align: left;
    display: flex;
    align-items: center;
`

export const Content = styled.div`
    background-color: #fff;
    border-radius: 16px;
    padding: 20px 40px;
    min-height: 80vh;

    @media screen and (max-width: 500px) {
        padding: 16px;
    }
`

export const Header = styled.header`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    @media screen and (max-width: 500px) {
        flex-direction: column;
    }
`
export const center = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}

export const flex = {
    display: 'flex',
}

export const flexWrap = {
    display: 'flex',
    flexWrap: 'wrap',
}

export const flexRow = {
    display: 'flex',
    flexDirection: 'row',
}

export const flexCenter = {
    display: 'flex',
    alignItems: 'center',
}

export const flexBetween = {
    display: 'flex',
    justifyContent: 'space-between',
}

export const purchaseBox = {
    display: 'flex',
    gridTemplateColumns: '70% 30%',
    gap: '20px',

    '@media screen and (max-width: 500px)': {
        flexWrap: 'wrap',
    },
}

export const languageBox = {
    ...flexCenter,
    gap: '12px',
    '@media screen and (max-width: 500px)': {
        marginBottom: '16px',
    },
}

export const paymentBox = {
    width: '100%',
    maxWidth: '400px',
}

export const fullWidth = {
    width: '100%',
}

export const stepperBox = {
    border: '1px solid #EEEEEE',
    padding: 2,
    borderRadius: 2,
}

export const timerBox = {
    width: '200px',
    border: '2px solid black',
    borderRadius: '8px',
    padding: '16px',
    position: 'relative',
    mr: 1,
}

export const discountBox = {
    background: '#FDE1E2',
    padding: '4px',
    color: '#EA4353',
    borderRadius: '4px',
    position: 'absolute',
    top: '-10px',
    right: '-16px',
}

export const promoText = {
    background: '#fff',
    border: '1px solid #9747FF',
    padding: '4px',
    color: '#9747FF',
    borderRadius: '4px',
    position: 'absolute',
    top: '-14px',
    left: '-16px',
    fontSize: '12px',
}

export const time = {
    fontSize: '20px',
    fontWeight: 500,
    mb: '2px',
}

export const timeTitle = {
    fontSize: '10px',
}

export const textCenter = {
    textAlign: 'center',
}

export const logo = {
    height: 60,
    width: 60,
    borderRadius: '50%',
    objectFit: 'cover',
}

export const packageBox = {
    display: 'flex',
    background: '#E5F4FF',
    padding: '16px',
    borderRadius: '16px',
    alignItems: 'center',
    mb: 2,
    mr: 4,
    flexGrow: 1,
}

export const packageDiscountBox = {
    display: 'grid',
    gridTemplateColumns: '70% 30%',
    alignItems: 'start',

    '@media screen and (max-width: 500px)': {
        display: 'grid',
        gridTemplateColumns: 'auto',
        gap: '16px',
        mb: 2,
        ml: 2,
    },
}

export const selectedBox = {
    borderRadius: '4px',
    position: 'absolute',
    top: '-15px',
    left: '-15px',
    background: '#fff',
    height: 30,
    width: 30,
}

export const circleRounded = {
    mr: 1,
    height: 30,
    width: 30,
}

export const tabTitle = {
    mb: 4,
    fontSize: '24px',
    fontWeight: 500,
}

export const summaryCardBox = {
    maxWidth: '400px',
    width: '100%',
}

export const exitPriceTitle = {
    background: '#fff',
    padding: '8px',
    textAlign: 'center',
    borderRadius: 1,
    fontWeight: 500,
    fontSize: '20px',
}

export const exitPriceBox = {
    background: '#FBFBFB',
    padding: 2,
    borderRadius: 2,
    display: 'grid',
    alignItems: 'start',
    gap: '16px',
}

export const discount = {
    background: '#FDE1E2',
    padding: '4px 8px',
    color: '#EA4353',
    borderRadius: '4px',
    ml: 2,
}

export const price = {
    color: '#9C9DA1',
    textDecoration: 'line-through',
}

export const discountPrice = {
    color: '#404A51',
    fontWeight: 500,
}

export const helpBox = {
    mb: 2,
    color: '#96AAB4',
    position: 'relative',
}

export const helpIcon = {
    position: 'absolute',
    top: '6px',
    left: '22px',
}

export const promocodeButton = {
    padding: 0,
    margin: 0,
    textAlign: 'left',
    justifyContent: 'start',
    textTransform: 'none',
}

export const fontMedium = {
    fontWeight: 500,
}
